<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="60px" label-suffix=":")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='姓名')
                    el-input.inputWidth(v-model='dataForm.name' clearable='')
              el-col(:md='6' :sm="12")
                el-form-item(label='手机' )
                    el-input.inputWidth(v-model='dataForm.tel' clearable='' maxlength='11')
              el-col(:md='6' :sm="12")
                el-form-item(label='身份证')
                    el-input.inputWidth(v-model='dataForm.code' clearable='')
              el-col(:md='6' :sm="12")
                el-form-item(label='主办方')
                    el-select.inputWidth(v-model="dataForm.orgId" placeholder="请选择" filterable clearable)
                        el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='级别')
                    el-select.inputWidth(v-model='dataForm.level',placeholder='请选择',clearable)
                        el-option(label="2.0" value="2.0")
                        el-option(label="2.5" value="2.5")
                        el-option(label="3.0" value="3.0")
                        el-option(label="3.5" value="3.5")
                        el-option(label="4.0" value="4.0")
                        el-option(label="4.5" value="4.5")
                        el-option(label="5.0" value="5.0")
              el-col(:md='6' :sm="12")
                el-form-item(label='性别' )
                    el-select.inputWidth(v-model='dataForm.gender',placeholder='请选择',clearable)
                        el-option(label='男',value="0")
                        el-option(label='女',value="1")
              el-col(:md='6' :sm="12")
                el-form-item(label='职业')
                    el-select.inputWidth(v-model='dataForm.position',placeholder='请选择',clearable)
                        el-option(label='学生',value="1")
                        el-option(label='在职',value="2")
        el-row(style="padding-bottom:15px;")
          el-col(:span="24")
            el-button(@click='addOrUpdateHandle()',type='primary') 新增
            el-button(v-if="isAuth('sys:user:delete')", type='danger', @click='deleteHandle()', :disabled='dataListSelections.length <= 0') 删除
            el-button(@click='exportExcel()',type='primary') 导出
            el-button(@click='getDataList()',type='primary',icon='el-icon-search',style="float:right;") 查 询
        el-table(:data="tableData" id="out-table" style="width: 100%" , @selection-change='selectionChangeHandle' v-loading='dataListLoading' border)
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='name',header-align='center',align='center',label='姓名')
            el-table-column(prop='tel',header-align='center',align='center',label='手机号'  width='130')
            el-table-column(prop='code',header-align='center',align='center',label='身份证号' width='170')
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='level',header-align='center',align='center',label='级别'  width='80')
            el-table-column(prop='gender',header-align='center',align='center',label='性别'  width='80')
               template(slot-scope="scope")
                   span(v-if='scope.row.gender === 0') 男
                   span(v-if='scope.row.gender === 1' type='danger') 女
            el-table-column(prop='position',header-align='center',align='center',label='职业'  width='80')
               template(slot-scope="scope")
                   span(v-if='scope.row.position == 1') 学生
                   span(v-if='scope.row.position == 2') 在职
            el-table-column(prop='email',header-align='center',align='center',label='邮箱')
            el-table-column(prop='byx1',header-align='center',align='center',label='账户关联' )
              template(slot-scope="scope")
                   span(v-if='scope.row.byx1') 已关联
                   span(v-if='!scope.row.byx1') 未关联
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(:collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1"  @click="viewHandle(scope.row.id)") 查看详情
                                el-menu-item(index="1-2"  @click="addOrUpdateHandle(scope.row.id)") 修改
                                el-menu-item(index="1-3"  @click="deleteHandle(scope.row.id)") 删除
                                el-menu-item(index="1-3"  @click="showLinkAccount(scope.row)") 关联账户
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //新增-修改
        add-or-update(v-if='addOrUpdateVisible',ref='addOrUpdate',@refreshDataList='getDataList')
        view-info(v-if='viewVisible', ref='viewInfo', @refreshDataList='getDataList')
        AssociatedAccount(v-if='AssociatedVisible',ref='Associated',@refreshDataList='getDataList')
</template>

<script>
import table from './table.js'
import AddOrUpdate from './add-or-update'
import ViewInfo from './view-info'
import AssociatedAccount from './AssociatedAccount' //关联账户
export default {
  data () {
    return {
      AssociatedVisible: false,
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      dataForm: {
        name: '',
        tel: '',
        code: '',
        orgId: '',
        level: '',
        gender: '',
        position: ''
      },
      orgName: '',
      tableData: [],
      dataListSelections: [],
      sysOrgList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      viewVisible: false,
      exportDatas: [] //导出数据集合
    }
  },
  components: {
    AddOrUpdate,
    ViewInfo,
    AssociatedAccount
  },
  created () {
    this.getDataList()
    this.changeOrg()
  },
  methods: {
    // 关联账户设置
    showLinkAccount (row) {
      this.AssociatedVisible = true
      this.$nextTick(() => {
        this.$refs.Associated.init(row)
      })
    },
    //新增按钮事件
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    viewHandle (id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(id)
      })
    },
    // 导出
    exportExcel () {
      this.$http({
        url: this.$http.adornUrl('/ctReferee/getExportList'),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.dataForm.name,
          tel: this.dataForm.tel,
          code: this.dataForm.code,
          orgId: this.dataForm.orgId,
          gender: this.dataForm.gender,
          position: this.dataForm.position,
          level: this.dataForm.level
        })
      }).then(data => {
        if (data && data.code === 0) {
          console.log(data.list)
          if (data.list == null || data.list.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }
          let exportData = data.list
          for (let i of exportData) {
            i.gender = { 0: '男', 1: '女' }[i.gender]
            i.position = { 1: '学生', 2: '在职' }[i.position]
          }
          console.log('导出的订单数据：', exportData)
          this.$export.excel({
            columns: this.table.columns,
            data: exportData,
            title: '裁判信息'
          }).then(() => {
            this.$message.success('导出表格成功')
          })
        }
      })
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // excelDown() {
    //   this.$http({
    //     url: this.$http.adornUrl("/ctReferee/excelDown"),
    //     method: "post",
    //     data: {
    //       name: this.dataForm.name,
    //       tel: this.dataForm.tel,
    //       code: this.dataForm.code,
    //       orgId: this.dataForm.orgId,
    //       gender: this.dataForm.gender,
    //       position: this.dataForm.position,
    //       level: this.dataForm.level
    //     }
    //   }).then(data => {
    //     if(!data) return this.$message.error('导出数据失败！')
    //     this.exportDatas = data
    //     this.exportExcel()
    //   });
    // },
    // exportExcel(){
    //    //excel数据导出
    //     require.ensure([], () => {
    //         const {
    //             export_json_to_excel
    //         } = require('@/assets/exportxlxs/export2Excel');
    //         const tHeader =  ['姓名','手机号','身份证号','主办方','级别','性别','职业','邮箱'];
    //         const filterVal = ['name','tel','code','orgName','level','gender','position','email'];
    //         // const list = this.tableData;
    //         const list = this.exportDatas

    //         const data = this.formatJson(filterVal, list);
    //         // export_json_to_excel(tHeader, data, '裁判列表');
    //         export_json_to_excel({
    //           header: tHeader,
    //           data:data,
    //           // title:'',
    //           multiHeader:[],
    //           merges: [],
    //           filename: '裁判列表',
    //           autoWidth: true,
    //           bookType: 'xlsx'
    //         });

    //     })
    // },
    formatJson (filterVal, jsonData) {
      let position_obj = {
        '1': '学生',
        '2': '在职'
      }
      let xbobj = {
        0: '男',
        1: '女'
      }
      jsonData.forEach(e => {
        e.position = position_obj[e.position]
        e.gender = xbobj[e.gender]
        for (let key in e) {
          e[key] = e[key] || ' '
        }
      })
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    // exportExcel() {
    //     $('#out-table tr').find('td:eq(0)').addClass('noExl')
    //     $('#out-table tr').find('th:eq(0)').addClass('noExl')
    //     $('#out-table tr').find('td:eq(9)').addClass('noExl')
    //     $('#out-table tr').find('th:eq(9)').addClass('noExl')
    //     $('#out-table tr').find('.gutter').addClass('noExl')
    //     $("#out-table").table2excel({
    //         // 不被导出的表格行的CSS class类
    //         exclude: ".noExl",
    //         // 导出的Excel文档的名称
    //         name: "裁判信息",
    //         // Excel文件的名称
    //         filename: "裁判列表",
    //         //文件后缀名
    //         fileext: ".xls"
    //     });
    // },

    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },

    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/ctReferee/list'),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.dataForm.name,
          tel: this.dataForm.tel,
          code: this.dataForm.code,
          orgId: this.dataForm.orgId,
          gender: this.dataForm.gender,
          position: this.dataForm.position,
          level: this.dataForm.level
        })
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    changeOrg () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 删除
    deleteHandle (id) {
      var ids = id
        ? [id]
        : this.dataListSelections.map(item => {
          return item.id
        })
      this.$confirm(`是否删除裁判？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl('/ctReferee/delete'),
            method: 'post',
            data: this.$http.adornData(ids, false)
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
        .catch(() => { })
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';
.inputWidth {
  width: 210px;
}
</style>
